<div class="card-body">

  <form>

    <div class="row">

      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">آیا مشتری روش خاصی برای کالیبراسیون درخواست نموده‌است؟</label>
        <select class="custom-select" [(ngModel)]="s1" name="s1">
          <option value="1">بله</option>
          <option value="0">خیر</option>
        </select>
      </div>

      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">آیا نیاز به خدمات پیمانکار فرعی وجود دارد؟ </label>
        <select class="custom-select" [(ngModel)]="s2" name="s2">
          <option value="1">بله</option>
          <option value="0">خیر</option>
        </select>
      </div>

    </div>

    <div class="row" [hidden]="s1=='0'">

      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">مشتری چه روشی(طبق چه استانداردی) پیشنهاد کرده است؟</label>
        <textarea class="form-control" [(ngModel)]="s1_1" name="s1_1"
          placeholder="اینجا تایپ کنید ..."></textarea>
      </div>

      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">آیا دستورالعمل روش درخواست شده و امکانات در آزمایشگاه بهینه وجود دارد؟ </label>
        <select class="custom-select" [(ngModel)]="s1_2" name="s1_2">
          <option value="1">بله</option>
          <option value="0">خیر</option>
        </select>
      </div>

    </div>

    <div class="row">

      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">امکان اجرا و تحویل در زمان مورد درخواست مشتری وجود دارد؟ </label>
        <select class="custom-select" [(ngModel)]="s3" name="s3">
          <option value="1">بله</option>
          <option value="0">خیر</option>
        </select>
      </div>

      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">آیا این درخواست از نظر مالی به صلاح شرکت‌ می‌باشد؟ </label>
        <select class="custom-select" [(ngModel)]="s4" name="s4">
          <option value="1">بله</option>
          <option value="0">خیر</option>
        </select>
      </div>

    </div>

    <div class="row">

      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">آیا سازگاری با ضوابط قانونی و سیاست‌های شرکت بهینه فرآیند آزما وجود دارد؟ </label>
        <select class="custom-select" [(ngModel)]="s5" name="s5">
          <option value="1">بله</option>
          <option value="0">خیر</option>
        </select>
      </div>

      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">کالیبراسیون تمام تجهیزات مورد درخواست توسط آزمایشگاه بهینه امکان‌پذیر است؟ </label>
        <select class="custom-select" [(ngModel)]="s6" name="s6">
          <option value="1">بله</option>
          <option value="0">خیر</option>
        </select>
      </div>

    </div>

    <div class="row">

      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">کالیبراسیون تمام تجهیزات مورد درخواست توسط پیمانکار فرعی امکان‌پذیر است؟ </label>
        <select class="custom-select" [(ngModel)]="s7" name="s7">
          <option value="0">بلی- در حال حاضر نیازی نیست</option>
          <option value="1">بلی – به مشتری اطلاع رسانی می شود</option>
          <option value="2">خیر</option>
        </select>
      </div>

      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">امکان کالیبراسیون برخی از تجهیزات وجود ندارد؟</label>
        <select class="custom-select" [(ngModel)]="s8" name="s8">
          <option value="1">بله</option>
          <option value="0">خیر</option>
        </select>
      </div>

    </div>

    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">بنا به دلایل زیر، از قبول درخواست مشتری خودداری می‌شود</label>
        <textarea class="form-control" [(ngModel)]="s9" name="s9"
          placeholder="اینجا تایپ کنید ..."></textarea>
      </div>
    </div>

    <br />
    <br />
    <br />

    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!InProccessing" (click)="OnSubmit()" type="button" class="btn btn-success"
      style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>


  </form>



</div>